import { createBrowserRouter, RouterProvider, ScrollRestoration } from "react-router-dom";
import Footer from './footer/Footer';
import Header from './header/Header';
import Home from './main/Home';
import Projekte from './main/Projekte';
import About from "./main/About";
import Leistung from './main/Leistung';
import Kontakt from './main/Kontakt';
import Impressum from './main/Impressum';
import './scss/styles.scss';
const router = createBrowserRouter([
  {
    path: "/",
    element: <>
      <Header noBackground />
      <Home />
      <ScrollRestoration />
    </>,
  }, {
    path: "/projekte",
    element: <>
      <Header />
      <Projekte />
      <Footer />
      <ScrollRestoration />
    </>,
  }, {
    path: "/ueber-mich",
    element: <>
      <Header />
      <About />
      <Footer />
      <ScrollRestoration />
    </>
  }, {
    path: "/leistung",
    element: <>
      <Header />
      <Leistung />
      <Footer />
      <ScrollRestoration />
    </>
  }, {
    path: "/kontakt",
    element: <>
      <Header />
      <Kontakt />
      <Footer />
      <ScrollRestoration />
    </>
  }, {
    path: "/impressum",
    element: <>
      <Header />
      <Impressum />
      <Footer />
      <ScrollRestoration />
    </>
  }
])

function App() {
  return <RouterProvider router={router} />;
}

export default App;
